import { createSvgIcon } from '@mui/material/utils'

const ConfirmPlate = createSvgIcon(
  <>
    <path
      d="M75.17 6.19C72.53 6.19 70.39 8.35 70.39 11C70.39 11.99 70.69 12.92 71.2 13.68C71.2 13.77 71.21 13.86 71.21 13.94C71.21 14.41 71.21 14.78 70.96 15.17C70.43 16 69.68 16.25 68.76 16.41C69.16 16.69 70.01 16.6 70.5 16.6C71.09 16.6 71.63 16.68 72.12 16.36C72.59 16.06 73.08 15.71 73.62 15.55C74.1 15.71 74.62 15.81 75.15 15.81C77.79 15.81 79.93 13.66 79.93 11C79.93 8.34 77.79 6.19 75.15 6.19H75.17Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M79.6701 0.0499878C79.6701 0.0499878 80.2401 5.56999 77.6801 6.71999"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M78 6.96998C78 6.96998 81.34 2.33998 85.78 3.81998"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M78.21 7.10998C78.21 7.10998 80.93 4.06998 84.33 6.17998"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M51.14 12.42C51.77 13.35 52.93 13.72 54.1 13.48C53.98 14.12 54.09 14.76 54.45 15.3C55.11 16.27 56.4 16.6 57.61 16.2C57.67 16.38 57.76 16.55 57.87 16.71C58.67 17.89 60.42 18.09 61.78 17.17C63.14 16.25 63.6 14.55 62.81 13.37C62.7 13.21 62.57 13.07 62.43 12.94C63.25 11.97 63.43 10.65 62.77 9.66999C62.4 9.12999 61.84 8.78999 61.21 8.65999C61.86 7.66999 61.95 6.44999 61.32 5.51999C60.66 4.53999 59.39 4.17999 58.17 4.49999C58.15 4.11999 58.03 3.75999 57.82 3.43999C57.08 2.34999 55.47 2.15999 54.21 3.00999C54.13 3.05999 54.07 3.11999 54 3.17999L52.98 1.67999L50.7 3.21999L51.72 4.71999C51.64 4.75999 51.56 4.79999 51.49 4.84999C50.23 5.69999 49.81 7.26999 50.54 8.35999C50.76 8.67999 51.05 8.91999 51.39 9.07999C50.63 10.1 50.5 11.41 51.16 12.39L51.14 12.42Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M59.57 13.93L53.48 4.91998" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M60.85 10.95L59.13 10.23" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M58.6 7.60999L56.88 6.89999" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M56.32 14.01L56.3 12.15" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M54.06 10.68L54.04 8.82001" stroke="#204ECF" strokeLinejoin="round" />
    <path
      d="M16.75 56.6C15.97 54.81 13.3 55.27 12.55 53.4C12.13 52.35 12.35 51.14 11.96 50.08C11.61 49.12 11 48.27 10.2 47.66C9.34 47.01 8.69 46.55 8.22 45.55C7.76 44.58 8.02 43.33 7.77 42.25C7.58 41.41 7.23 40.43 6.7 39.7C6.1 38.86 5.27 38.6 4.48 38.06C4.44 38.04 4.41 38.01 4.37 37.99"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M59.5 69.7C60.31 67.92 58.17 66.25 59.06 64.44C59.56 63.43 60.6 62.77 61.13 61.78C61.61 60.87 61.83 59.85 61.74 58.85C61.65 57.78 61.55 56.98 61.98 55.96C62.39 54.97 63.49 54.32 64.13 53.42C64.62 52.72 65.12 51.79 65.31 50.92C65.53 49.91 65.17 49.12 65.04 48.18C65.04 48.14 65.03 48.1 65.02 48.05"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M9.38998 10.13C9.16998 12.35 7.26998 13.97 5.13998 13.75C3.00998 13.53 1.44998 11.54 1.66998 9.31999C1.88998 7.09999 3.78998 5.47999 5.91998 5.69999C6.96998 5.80999 7.87998 6.34999 8.50998 7.12999C9.15998 7.93999 9.49998 8.99999 9.38998 10.13V10.13Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M2.83997 1.26999C2.83997 1.26999 5.00997 2.91999 5.26997 5.64999"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M83.52 27.31C83.37 28.81 82.09 29.91 80.65 29.75C79.21 29.6 78.16 28.26 78.3 26.76C78.45 25.26 79.73 24.16 81.17 24.32C81.88 24.39 82.5 24.76 82.92 25.29C83.36 25.83 83.59 26.55 83.52 27.31V27.31Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M79.1 21.32C79.1 21.32 80.56 22.44 80.74 24.28"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M4.47 68.07C2.31 66.43 1.86 63.39 3.47 61.28C5.08 59.17 8.12 58.79 10.28 60.43C12.44 62.07 17.34 71.83 17.34 71.83C17.34 71.83 6.63 69.71 4.47 68.07V68.07Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M0.300049 58.88L7.85005 64.62" stroke="#204ECF" strokeLinejoin="round" />
    <path
      d="M5.08995 28.08C5.79135 28.08 6.35995 27.5114 6.35995 26.81C6.35995 26.1086 5.79135 25.54 5.08995 25.54C4.38854 25.54 3.81995 26.1086 3.81995 26.81C3.81995 27.5114 4.38854 28.08 5.08995 28.08Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M53.48 71.02C54.1814 71.02 54.75 70.4514 54.75 69.75C54.75 69.0486 54.1814 68.48 53.48 68.48C52.7786 68.48 52.21 69.0486 52.21 69.75C52.21 70.4514 52.7786 71.02 53.48 71.02Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M81.27 51.15C81.9714 51.15 82.54 50.5814 82.54 49.88C82.54 49.1786 81.9714 48.61 81.27 48.61C80.5686 48.61 80 49.1786 80 49.88C80 50.5814 80.5686 51.15 81.27 51.15Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M26.65 9.74001C27.04 9.94001 26.78 9.87001 27.46 9.96001C28.56 10.11 32.03 10.59 33.13 10.74C34.01 10.86 34.21 10.93 34.53 10.7C35.28 10.16 34.97 9.77001 32.91 4.47001C32.76 4.07001 32.54 3.69001 32.33 3.33001C32.01 2.77001 31.54 2.80001 31.1 3.24001C30.23 4.12001 29.66 4.81001 28.94 5.80001C28.26 6.74001 27.39 8.01001 26.63 8.89001C26.33 9.24001 26.49 9.66001 26.65 9.74001Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M14.11 12.51C13.58 13.13 13.35 13.93 13.48 14.73C13.58 15.34 14.02 16.1 14.68 16.04C15.72 15.94 15.36 15.47 15.82 15.11C16.18 14.83 16.76 14.86 17.05 15.23C17.88 16.31 15.9 17.4 15.22 17.8C14.61 18.16 13.8 18.55 13.33 19.06C12.66 19.79 12.41 20.67 12.61 21.73C12.7 22.22 13.33 23.16 13.77 23.42C14.78 24.04 15.93 24.24 17.15 23.65C18.24 23.12 18.65 22.06 19 20.98C19.19 20.4 19.27 19.92 19.33 19.31C19.39 18.69 19.63 18.24 20.28 18.11C20.79 18.01 21.35 18.16 21.56 18.65C21.81 19.26 21.34 19.17 21.12 19.58C20.93 19.94 21.11 20.39 21.37 20.65C22.19 21.48 23.44 21.31 24.15 20.52C25.7 18.79 24.83 15.23 23.65 13.64C23.18 13.01 22.3 11.76 19.51 11.12C18.39 10.86 16.23 11 14.98 11.82C14.66 12.03 14.37 12.25 14.14 12.51H14.11Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M70.5999 65.0295L74.3422 59.4118C74.8799 58.6046 75.9754 58.3851 76.7827 58.9228L84.9886 64.3893C85.7959 64.9271 86.0154 66.0225 85.4776 66.8298L81.7353 72.4475C81.1976 73.2548 80.1021 73.4742 79.2948 72.9365L71.0889 67.47C70.2816 66.9322 70.0621 65.8368 70.5999 65.0295Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M70.5401 65.13L69.56 64.48C68.75 63.94 68.5301 62.84 69.0701 62.04L70.99 59.15C71.53 58.34 72.6301 58.12 73.4301 58.66L74.4101 59.31"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M66.16 58.01L69.79 60.43" stroke="#204ECF" strokeLinejoin="round" />
    <path
      d="M28.91 70.34C29.55 70.45 30.16 70.11 30.43 69.56C30.55 69.58 30.66 69.61 30.78 69.63C31.03 69.67 31.28 69.71 31.53 69.74C31.67 70.26 32.09 70.68 32.66 70.78C33.33 70.9 33.97 70.52 34.22 69.92C34.73 69.92 35.23 69.89 35.71 69.85C35.92 70.15 36.24 70.37 36.63 70.44C37.38 70.57 38.09 70.08 38.26 69.35C40.11 68.76 41.36 67.75 41.59 66.43C41.82 65.12 40.98 63.74 39.44 62.56C39.53 61.81 39.03 61.11 38.28 60.98C37.89 60.91 37.51 61.01 37.21 61.22C36.77 61.01 36.31 60.82 35.83 60.64C35.8 59.99 35.32 59.42 34.66 59.31C34.09 59.21 33.55 59.46 33.25 59.91C33.01 59.86 32.76 59.81 32.51 59.77C32.39 59.75 32.28 59.73 32.16 59.71C32.09 59.1 31.64 58.57 31 58.46C30.28 58.33 29.59 58.78 29.4 59.47C28.88 59.47 28.37 59.48 27.89 59.52C27.76 58.99 27.33 58.56 26.75 58.46C25.98 58.33 25.24 58.84 25.11 59.62C25.09 59.76 25.09 59.9 25.11 60.03C23.23 60.62 21.95 61.64 21.72 62.97C21.49 64.3 22.34 65.69 23.92 66.88C23.86 67 23.81 67.13 23.79 67.27C23.66 68.04 24.17 68.78 24.95 68.91C25.52 69.01 26.07 68.75 26.38 68.29C26.83 68.49 27.3 68.68 27.79 68.84C27.74 69.56 28.23 70.21 28.96 70.33L28.91 70.34Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M38.36 65.86L37.65 65.74" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M34.5201 65.19L33.8 65.07" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M30.6701 64.53L29.9601 64.4" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M26.83 63.86L26.11 63.73" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M29.1 61.76L28.39 61.63" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M32.83 62.02L32.12 61.89" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M36.74 63.09L36.03 62.96" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M28.26 66.6L27.54 66.48" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M31.86 67.62L31.14 67.49" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M35.9001 67.93L35.1901 67.81" stroke="#204ECF" strokeLinejoin="round" />
    <path
      d="M41.78 66.46C41.78 66.46 45.17 66.38 46.02 68.49"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M44.63 56.9C55.6757 56.9 64.63 47.9457 64.63 36.9C64.63 25.8543 55.6757 16.9 44.63 16.9C33.5843 16.9 24.63 25.8543 24.63 36.9C24.63 47.9457 33.5843 56.9 44.63 56.9Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M44.63 54.04C54.0962 54.04 61.77 46.3662 61.77 36.9C61.77 27.4339 54.0962 19.76 44.63 19.76C35.1638 19.76 27.49 27.4339 27.49 36.9C27.49 46.3662 35.1638 54.04 44.63 54.04Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M35.92 38.31L41.32 43.7L54.7 30.31" stroke="#204ECF" strokeMiterlimit="10" />
    <path
      d="M16.28 47.24C16.9814 47.24 17.55 46.6714 17.55 45.97C17.55 45.2686 16.9814 44.7 16.28 44.7C15.5786 44.7 15.01 45.2686 15.01 45.97C15.01 46.6714 15.5786 47.24 16.28 47.24Z"
      fill="#204ECF"
    />
    <path
      d="M43.31 8.88C44.0114 8.88 44.58 8.3114 44.58 7.61C44.58 6.90859 44.0114 6.34 43.31 6.34C42.6086 6.34 42.04 6.90859 42.04 7.61C42.04 8.3114 42.6086 8.88 43.31 8.88Z"
      fill="#204ECF"
    />
  </>,
  'ConfirmPlate'
)

export default ConfirmPlate
